module.exports = __webpack_public_path__ + "static/media/BankTransfer.e4f3cc09.svg";